import { render, staticRenderFns } from "./ModalLoginComerciante.vue?vue&type=template&id=3aa5aad6&"
import script from "./ModalLoginComerciante.vue?vue&type=script&lang=js&"
export * from "./ModalLoginComerciante.vue?vue&type=script&lang=js&"
import style0 from "./ModalLoginComerciante.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports